import { useEffect } from 'react';
import { useUser } from 'shared/hooks/use-user';
import {
  refreshDiagnosticsEnabled,
  registerDiagnosticsConsoleApi,
  startFirestoreDiagnosticsHeartbeat,
  stopFirestoreDiagnosticsHeartbeat,
} from 'shared/services/diagnostics';
import { isInternalUser } from 'shared/utils/is-internal-user';

// Internal users on the desktop app only. The Electron condition is what keeps
// this off in normal browser sessions; set the `firestore-diagnostics-force`
// localStorage key by hand to run it in a browser tab for reproduction.
//
// The flag itself is persisted in localStorage rather than derived per call, so
// a flag written in a previous session is already active at module-init time
// this session — that is what makes boot-time subscriptions observable at all
// (the user doc has not resolved yet while they are being created).
export const useFirestoreDiagnostics = () => {
  const user = useUser();
  const shouldEnable = isInternalUser(user?.email) && !!window.electron;

  useEffect(() => {
    refreshDiagnosticsEnabled(shouldEnable);
    registerDiagnosticsConsoleApi();

    if (!shouldEnable) {
      stopFirestoreDiagnosticsHeartbeat();
      return;
    }

    startFirestoreDiagnosticsHeartbeat();

    return () => {
      stopFirestoreDiagnosticsHeartbeat();
    };
  }, [shouldEnable]);
};
